// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608042243/js/" + chunkId + "." + {"44":"175085a7","225":"d2899433","481":"5e208844","486":"3c461455","770":"612fe417"}[chunkId] + ".0.5641198956139414.chunk.js";
};